<template>
<v-container id="main">
<v-row id="row" justify="center" >
      <v-col md="6">
        <v-card
        id="cards" 
        outlined
        class="white main--text pa-2" 
        rounded="xl" 
        align="center"
        height="100%"
        width="100%"
        elevation="15"
        >
        <v-col>
          <h3> Skip bins </h3>
          <p> 1.5 Cube - 7 Cube Skip Bins </p>
          <img src="@/assets/Skip bins.svg" alt="Avatar">
        </v-col>
        </v-card>
      </v-col>
       <v-col md="6">
        <v-card
        id="cards" 
        outlined
        class="main--text white pa-2"  
        rounded="xl"
        height="100%" 
        width="100%"
        align="center"
        elevation="20"
        
        >
        <v-col>
        <h3> Rorobins </h3>
        <p> 8 Cube - 33 Cube Roro Bins </p>
        <img src="@/assets/Roro.svg" alt="Avatar">
        </v-col>    
        </v-card>
      </v-col>
  </v-row>
  <v-row id="row" justify="center">
      <v-col md="6">
        <v-card
        id="cards" 
        outlined
        class="main--text white pa-2"  
        rounded="xl" 
        align="center"
        height="100%"
        width="100%"
        elevation="15"
        >
        <v-col>
        <h3> Tipper trucks </h3>
        <p> 1 Cube - 10 Cube trucks </p>
        <img src="@/assets/tippertruck.svg" alt="Avatar">
        </v-col>
        </v-card>
      </v-col>
       <v-col md="6">
        <v-card
        id="cards"
        outlined 
        class="main--text white pa-2"  
        rounded="xl" 
        align="center"
        height="100%"
        width="100%"
        elevation="15"
        >
        <v-col>
        <h3> Tanker trucks </h3>
        <p> 1000 Liter - 5000 liter trucks </p>
        <img src="@/assets/tankertruck.svg" alt="Avatar">
        </v-col> 
        </v-card>
      </v-col>
  </v-row>
</v-container>
</template>

<script>
export default {
  name: 'serviceType',
}
</script>

<style scoped>
@media only screen and (max-width: 580px){
 #row{
   display: block;
 }
}
</style>